import { Injectable } from '@angular/core';
import { Response } from '@angular/http';
import { HttpInterceptorService, RESTService } from '@covalent/http';
import { MOCK_API } from '../config/api.config';
import { Observable } from 'rxjs/Observable';
import { environment } from '../environments/environment';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

@Injectable ()
export class ConstantesService extends RESTService<any> {

  constructor(private _http: HttpInterceptorService) {
    super(_http, {
      baseUrl: MOCK_API,
      path: '/obtenerPlanTratamientoPaciente',
    });
  }

  obtenerConstantesPaciente (idPaciente: string, sexo: string, fechaNacimiento: string): any {
    return this._http.post(environment.api_host + 'constantes/obtenerConstantesPaciente',
      {
        idPaciente: idPaciente,
        sexo: sexo,
        fechaNacimiento: fechaNacimiento,
      })
      .map ((res: Response) => res.json())
      .catch ((error: any) => Observable.throw(error.json().error || 'Service error'));
  }
  obtenerConstantesPacienteByNumExpediente (idPaciente: string): any {
    return this._http.post(environment.api_host + 'constantes/obtenerConstantesPacienteByNumExpediente',
      {
        idPaciente: idPaciente,
      })
      .map ((res: Response) => res.json())
      .catch ((error: any) => Observable.throw(error.json().error || 'Service error'));
  }

   altaConstante(params: any): Observable<boolean> {
    return this._http.post(environment.api_host + 'constantes/altaConstante', params).map((res: Response) => {
      let respuesta: any = res.json();
      if (respuesta.error !== undefined) {
        return false;
      } else if (respuesta.respuesta.resultado === 'OK') {
        return true;
      } else {
        return false;
      }
    }).catch ((error: any) => Observable.throw(false));
  }

}



// WEBPACK FOOTER //
// ./src/services/constantes.service.ts